@if (!loading()) {
  <h1 mat-dialog-title>Gegevens aanpassen</h1>
  <div mat-dialog-content>
    <form (ngSubmit)="save()" [formGroup]="userForm">
      <div class="info-group">
        <h4 class="info-title">Basis</h4>
        <mat-form-field>
          <mat-label>Voor- & achternaam</mat-label>
          <input formControlName="name" type="text" autocomplete="name" matInput placeholder="Naam" />
          @if (userForm.controls.name.hasError('required')) {
            <mat-error>Voor- & achternaam is verplicht.</mat-error>
          }
        </mat-form-field>
        @if (dataStore.publicSettings.askGender) {
          <mat-form-field>
            <mat-label>Geslacht</mat-label>
            <mat-select formControlName="gender">
              <mat-option value="Man">Man</mat-option>
              <mat-option value="Vrouw">Vrouw</mat-option>
              <mat-option value="Anders">Anders</mat-option>
            </mat-select>
            @if (userForm.controls.gender.hasError('required')) {
              <mat-error>Geslacht is verplicht.</mat-error>
            }
          </mat-form-field>
        }
        @if (dataStore.publicSettings.askBirthDay) {
          <mat-form-field>
            <mat-label>Geboortedatum</mat-label>
            <input formControlName="birthDate" autocomplete="bday" matInput [matDatepicker]="picker" />
            <mat-datepicker-toggle matSuffix aria-label="Kalender openen" [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (userForm.controls.birthDate.hasError('required')) {
              <mat-error>Geboortedatum is verplicht.</mat-error>
            }
          </mat-form-field>
        }
      </div>
      <div class="info-group">
        <h4 class="info-title">Adres</h4>
        <mat-form-field>
          <mat-label>Postcode</mat-label>
          <input formControlName="postal" matInput autocomplete="postal-code" #postalCode placeholder="Postcode" />
          @if (userForm.controls.postal.hasError('required')) {
            <mat-error>Postcode is verplicht.</mat-error>
          }
          @if (userForm.controls.postal.hasError('postalValidator')) {
            <mat-error>Vul een geldige postcode in.</mat-error>
          }
        </mat-form-field>
        <div class="form-field-group">
          <mat-form-field>
            <mat-label>Huisnummer</mat-label>
            <input
              formControlName="houseNumber"
              autocomplete="address-line2"
              matInput
              placeholder="Huisnummer"
              (input)="formatNumericInput($event, userForm, 'houseNumber', true)"
            />
            @if (userForm.controls.houseNumber.hasError('required')) {
              <mat-error>Huisnummer is verplicht.</mat-error>
            }
            @if (
              userForm.controls.houseNumber.hasError('numberInput') || userForm.controls.houseNumber.hasError('pattern')
            ) {
              <mat-error>Vul een geldig huisnummer in.</mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Toevoeging</mat-label>
            <input formControlName="houseNumberAddition" autocomplete="off" matInput placeholder="Toevoeging" />
          </mat-form-field>
        </div>
        <mat-form-field>
          <mat-label>Straatnaam</mat-label>
          <input readonly formControlName="streetName" autocomplete="address-line1" matInput placeholder="Straatnaam" />
          @if (postcodeApiService.fetchingAddress()) {
            <mat-spinner [diameter]="18" class="field-centered-spinner"></mat-spinner>
          }
          @if (userForm.controls.streetName.hasError('required')) {
            <mat-error>Straatnaam is verplicht.</mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>Woonplaats</mat-label>
          <input readonly formControlName="city" autocomplete="address-level2" matInput placeholder="Woonplaats" />
          @if (postcodeApiService.fetchingAddress()) {
            <mat-spinner [diameter]="18" class="field-centered-spinner"></mat-spinner>
          }
          @if (userForm.controls.city.hasError('required')) {
            <mat-error>Woonplaats is verplicht.</mat-error>
          }
        </mat-form-field>
      </div>
      @if (dataStore.selectedOrganisation.particularities?.length > 0) {
        <div class="info-group">
          <h4 class="info-title">Bijzonderheden</h4>
          <div class="icons">
            @for (particularity of dataStore.selectedOrganisation.particularities; track particularity.id) {
              <div
                class="icon"
                role="button"
                tabindex="0"
                [ngClass]="{ active: userForm.value.particularityIds.includes(particularity.id) }"
                [attr.aria-label]="
                  userForm.value.particularityIds.includes(particularity.id)
                    ? 'Bijzonderheid deselecteren: ' + particularity.name
                    : 'Bijzonderheid selecteren: ' + particularity.name
                "
                [attr.aria-pressed]="userForm.value.particularityIds.includes(particularity.id)"
                [matTooltip]="particularity.name"
                (click)="toggleParticularity(particularity.id)"
                (keydown.enter)="toggleParticularity(particularity.id)"
                (keydown.space)="$event.preventDefault(); toggleParticularity(particularity.id)"
              >
                <mat-icon [svgIcon]="particularity.id"></mat-icon>
              </div>
            }
          </div>
        </div>
      }
    </form>
  </div>
}

@if (!loading()) {
  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Annuleren</button>
    <button
      mat-flat-button
      (click)="save()"
      [disabled]="awaitingResponse() || !userForm.valid || postcodeApiService.fetchingAddress()"
      [class.spinner]="awaitingResponse()"
    >
      Opslaan
    </button>
  </div>
}
